import { render, staticRenderFns } from "./EditTestTopic.vue?vue&type=template&id=51539566"
import script from "./EditTestTopic.vue?vue&type=script&lang=js"
export * from "./EditTestTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports